import { Action } from '@ngrx/store';
import { RegistrationForm } from "../shared/models/registration-form/registration-form.model";
import * as RegistrationFormAction from '../actions/registrationform.action';

const initialState: RegistrationForm = null

export function RegistrationFormReducer(state: RegistrationForm = initialState, action: RegistrationFormAction.Actions) {

    switch(action.type) {
        case RegistrationFormAction.CREATE_RegistrationForm:
            if (action.payload != state)
                state = action.payload;
            return state;
        default:
            return state;
    }
}